import LeadsTrash from "./components/LeadsTrash";

export default LeadsTrash;
